// REDESIGN 2024

export const navigationElement: HTMLElement | null = document.querySelector('[data-navigation]');

export const dynamicNavigation: HTMLElement | null = document.querySelector(
  '[data-dynamic-navigation]'
);

export const breakingNewsElement: HTMLElement | null =
  document.querySelector('[data-breaking-news]');
